
<app-incident-filters *ngIf="enableDisplayFilter"
  [params]="_params" 
  [customButton1Text]="enableUpdateFilterButton ? 
  'Actualizar Correlativos' : ''" 
  (onCustomButton1)="enableUpdateFilterButton ? updateMonthlyIds(): null"
  [enableExportButton]="true"
></app-incident-filters>

<div id="selected-incident" class="alert alert-secondary" *ngIf="enableSelectedRows && tableConfig?.Elements?.length">
  <h5 class="d-inline-block mr-2">Evento Seleccionado:</h5> 
  <p class="d-inline-block mb-0" id="incident-info" *ngIf="!incidentSelected">No se ha seleccionado ningún evento.</p>
  <p class="d-inline-block mb-0" *ngIf="incidentSelected"> {{'ID — ' +incidentSelected?.IncidentID+ ''}}.</p>
</div>

<app-custom-table 
  #incidentTable
  [data]="tableConfig" 
  [enablePagination]="true"
  [enableRowsPerPage]="true"
  [enableRadioSelected]="enableSelectedRows"
  (onSelectedRow)="onRowSelected($event)"
  [loadData]="loadIncidentData == 1 ? true : false"
></app-custom-table>

<app-incident-management-modal
  #incidentModal
  (onClose)="onCloseSettings($event)"
  [data]="incidentElements ? incidentElements : null"
  (dataChange)="saveDataElements($event)"
></app-incident-management-modal>
